import React from 'react';
import { Button, useAnalytics } from 'telia-front-react';
import { TranslationsContext } from '@telia-common-components/shared';
import { useInternetOffers } from './InternetOffersProvider';
import { useInternetCalculator } from './InternetCalculatorProvider';
const AddressSearchPopUp = (props) => {
    const { translate } = React.useContext(TranslationsContext);
    const { tier, addressId, roomId } = props;
    const { push } = useAnalytics();
    const { onAddressChange } = useInternetOffers();
    const { urlData } = useInternetCalculator();
    const openAddressSearchPopUp = () => {
        const url = urlData.getAddressSearchPopUpURL(tier, addressId, roomId);
        const ressWindow = open(url, 'winLov', 'Scrollbars=1,resizable=1,width=800,height=600');
        if (ressWindow.opener != null) {
            ressWindow.opener.transferAddr = async (...params) => {
                const [id, , , , , , , bg_room, , , building_id, , , , , room_id] = params;
                await onAddressChange({ id: id, apartment: bg_room, buildingId: building_id }, { roomId: room_id, roomName: bg_room });
            };
        }
        if (ressWindow.opener == null) {
            ressWindow.opener = self;
            ressWindow.focus();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { element: 'button', text: translate(!addressId ? 'addressSearchPopUp.button.label.chooseAddress' : 'addressSearchPopUp.button.label.changeAddress'), link: true, onClick: () => {
                push(!!addressId ? 'Link - Modal - Muuda aadressiotsingus' : 'Link - Modal - Vali asukoht aadressiotsingust');
                openAddressSearchPopUp();
            }, size: 'small', type: 'employee' })));
};
export default AddressSearchPopUp;
